"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SelectItem;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const colors = {
  border: {
    active: _intents.default.ux.navigate.foregroundColor,
    normal: _intents.default.ux.boxLowContrast.borderColor,
    hover: _intents.default.ux.actionControl.foregroundColor
  },
  background: {
    active: 'var(--ux-cup4ju)',
    normal: 'transparent'
  }
};
const SmallWrapper = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "SmallWrapper",
  class: "pl-sk359o3",
  vars: {
    "sk359o3-0": [({
      selected
    }) => selected ? colors.border.active : colors.border.normal],
    "sk359o3-2": [({
      selected
    }) => selected ? colors.border.active : colors.border.hover],
    "sk359o3-3": [({
      selected
    }) => selected ? colors.background.active : colors.background.normal]
  }
});
const LargeWrapper = /*#__PURE__*/(0, _react2.styled)(SmallWrapper)({
  name: "LargeWrapper",
  class: "pl-l135z74y"
});
function SelectItem({
  id,
  eid,
  icon,
  text,
  type = 'small',
  selected = false,
  onSelect = () => {}
}) {
  const Wrapper = type === 'large' ? LargeWrapper : SmallWrapper;
  (0, _react.useEffect)(() => {
    if (eid && selected) {
      (0, _patternLibraryUtils.logEvent)({
        eid,
        type: 'click'
      });
    }
  }, [selected, eid]);
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    "data-cy": 'select-item',
    onClick: () => onSelect(id, !selected),
    selected: selected
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: icon
  }), /*#__PURE__*/_react.default.createElement("span", null, text));
}
SelectItem.propTypes = {
  id: _propTypes.default.string,
  eid: _propTypes.default.string,
  icon: _propTypes.default.string,
  text: _propTypes.default.string,
  type: _propTypes.default.oneOf(['small', 'large']),
  selected: _propTypes.default.bool,
  onSelect: _propTypes.default.func
};